import React, { useEffect, useState, useRef } from 'react';
import './Navbar.css';

const sections = [
  { id: 'home', label: 'Home' },
  { id: 'menu', label: 'Menu' },
  { id: 'about', label: 'About' },
  { id: 'gallery', label: 'Gallery' },
  { id: 'contact', label: 'Contact' }
];

export default function Navbar() {
  const [activeSection, setActiveSection] = useState('home');
  const isClickScrolling = useRef(false);
  const scrollTimeout = useRef(null);

  // Move handleScroll outside useEffect so it can be called from handleClick
  const handleScroll = () => {
    if (isClickScrolling.current) return;
    const scrollPosition = window.scrollY + 120;
    let current = 'home';
    for (const section of sections) {
      const el = document.getElementById(section.id);
      if (el && el.offsetTop <= scrollPosition) {
        current = section.id;
      }
    }
    setActiveSection(current);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleClick = (id) => {
    isClickScrolling.current = true;
    setActiveSection(id);
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
      // Wait for scroll to finish, then allow scroll spy again
      if (scrollTimeout.current) clearTimeout(scrollTimeout.current);
      scrollTimeout.current = setTimeout(() => {
        isClickScrolling.current = false;
        handleScroll(); // <-- Call handleScroll after scroll finishes
      }, 700); // 700ms should be enough for smooth scroll
    } else {
      isClickScrolling.current = false;
    }
  };

  return (
    <nav className="navbar">
      <ul className="navbar-links">
        {sections.map((section) => (
          <li key={section.id}>
            <a
              href={`#${section.id}`}
              className={activeSection === section.id ? 'active' : ''}
              onClick={e => {
                e.preventDefault();
                handleClick(section.id);
              }}
            >
              {section.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}

